<template>
  <Teleport to="body">
    <div
      v-if="props.visible"
      class="modal fade show"
      :class="opened ? 'back-ani-on' : 'back-ani-off'"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      style="z-index: 11000"
      @click.stop="onBackClick"
    >
    <div
      class="modal-dialog modal-dialog-centered modal-sm"
      style="margin-left: 1rem; margin-right: 1rem;"
      @click.stop="() => {}"
    >
      <div class="modal-content popup-content">
        <div class="popup-inner" :class="{ 'popup-inner--compact': props.compact }">
          <div class="popup-header" :class="{ 'popup-header--compact': props.compact }">
            <h5 class="popup-title">
              <!-- {{ props.title }} -->
            </h5>
            <button
              type="button"
              class="popup-close-btn"
              aria-label="Close"
              @click.stop="onCloseClick"
            >
              <i class="fa-solid fa-x"></i>
            </button>
          </div>

          <div class="popup-body" :class="opened ? 'content-ani-on' : 'content-ani-off'">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script setup>
import { defineProps, ref, watch } from 'vue';

const opened = ref(false);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '알림',
  },
  okText: {
    type: String,
    default: '확인',
  },
  cancelText: {
    type: String,
    default: '취소',
  },
  okCallback: {
    type: Function,
  },
  closeCallback: {
    type: Function,
  },
  cancelCallback: {
    type: Function,
  },
  showCancel: {
    type: Boolean,
    default: true,
  },
  clickable: {
    type: Boolean,
    default: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

watch(
  () => props.visible,
  (v) => {
    opened.value = v;
  },
  { immediate: true }
);

const onOkClick = () => {
  if (props.okCallback) {
    props.okCallback();
  }
};

const onCancelClick = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
};

const onCloseClick = () => {
  if (props.closeCallback) {
    props.closeCallback();
  } else if (props.cancelCallback) {
    props.cancelCallback();
  }
  //    else if (props.okCallback) {
  //     props.okCallback();
  //   }
};

const onBackClick = () => {
  if (props.clickable) {
    onCloseClick();
  }
};
</script>

<style scoped>
.popup-content {
  border-radius: 1.2rem;
  overflow: hidden;
  padding: 0;
}

.popup-inner {
  padding: 1.5rem;
}

.popup-inner--compact {
  padding-top: 1.05rem;
  padding-bottom: 1.25rem;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  position: relative;
  z-index: 10;
}

.popup-header--compact {
  margin-bottom: 0.875rem;
}

.popup-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #212529;
  margin: 0;
}

.popup-close-btn {
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  position: relative;
  z-index: 11;
}

.popup-close-btn:hover {
  background-color: #f8f9fa;
  color: #212529;
}

.popup-body {
  /* padding은 popup-inner에서 처리 */
}

.back-ani-off {
  display: block;
  background-color: rgba(0, 0, 0, 0);
}

.back-ani-on {
  display: block;
  background-color: rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
}

.content-ani-off {
  opacity: 0;
}

.content-ani-on {
  opacity: 1;
  transition: all 0.3s;
}
</style>